import { render, staticRenderFns } from "./LabLog.vue?vue&type=template&id=7895b5a6&scoped=true&"
import script from "./LabLog.vue?vue&type=script&lang=ts&"
export * from "./LabLog.vue?vue&type=script&lang=ts&"
import style0 from "./LabLog.vue?vue&type=style&index=0&id=7895b5a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7895b5a6",
  null
  
)

export default component.exports